import React from 'react'
import PropTypes from 'prop-types'
import Player from '@app/components/Player'
import Api from '@app/api'
import _ from 'lodash'

const Task = ({ route, global: { olympiads } }) => {
  const { history, match: { params: { olympiad_id, id } } } = route
  const olympiad = _.find(olympiads, _.matchesProperty('id', olympiad_id))
  const handleBack = () => history.replace('/teachers/tasks')

  return (
    <Player
      src={Api.teachers.tasks({ olympiad_id: olympiad.id, id }).routes.resourcesURL}
      onBack={handleBack}
    />
  )
}

Task.propTypes = {
  route: PropTypes.object.isRequired,
  global: PropTypes.object.isRequired
}

export default Task
